import { client } from "Service/axios";

import {
  ExpenseUpdateRequest,
  PaginatedExpenseListList,
  PaginatedExpenseVehicleList,
} from "Shared/Types/fleetmanagementapi";
import {
  IExpenseLimitParams,
  IExpenseSearchParams,
} from "Shared/Types/expense";
import {
  EXPENSE,
  EXPENSE_TYPES,
  EXPENSE_UPDATE,
  EXPENSE_CREATE,
  EXPENSE_DELETE,
  EXPENSE_DETAIL,
  VEHICLES_WITH_EXPENSES,
  EXPENSE_COMMENT_DELETE,
  EXPENSE_COMMENT_CREATE,
  EXPENSE_DOCUMENT_DELETE,
  EXPENSE_DOCUMENT_CREATE,
} from "Shared/Constants/apiRequest";
import {
  PaginatedExpenseTypeList,
  ExpenseCreateRequest,
  PatchedExpenseTypeRequest,
} from "Shared/Types/fleetmanagementapi";

class Expense {
  getExpenseList(params: IExpenseSearchParams | null) {
    return client.get<PaginatedExpenseListList>(EXPENSE, { params });
  }

  getVehiclesWithExpense(params: IExpenseSearchParams | null) {
    return client.get<PaginatedExpenseVehicleList>(VEHICLES_WITH_EXPENSES, {
      params,
    });
  }

  deleteExpense(id: string) {
    return client.delete<any>(EXPENSE_DELETE(id));
  }
  createExpense(data: ExpenseCreateRequest) {
    return client.post(EXPENSE_CREATE, data);
  }
  updateExpense(id: string, data: ExpenseUpdateRequest) {
    return client.patch(EXPENSE_UPDATE(id), data);
  }
  getExpenseTypes(params: IExpenseLimitParams) {
    return client.get<PaginatedExpenseTypeList>(EXPENSE_TYPES, { params });
  }
  createExpenseTypes(data: PatchedExpenseTypeRequest) {
    return client.post(EXPENSE_TYPES, data);
  }
  getExpenseDetail(id: string) {
    return client.get(EXPENSE_DETAIL(id));
  }
  deleteExpenseComment(id: string) {
    return client.delete(EXPENSE_COMMENT_DELETE(id));
  }
  createExpenseComment(data: any) {
    return client.post(EXPENSE_COMMENT_CREATE, data);
  }
  deleteExpenseDocument(id: string, files: any) {
    return client.post(EXPENSE_DOCUMENT_DELETE(id), files);
  }
  createExpenseDocument(id: string, files: any) {
    return client.post(EXPENSE_DOCUMENT_CREATE(id), files);
  }
}

export default Expense;
